import { render } from "./DoLogout.vue?vue&type=template&id=5679382b"
import script from "./DoLogout.vue?vue&type=script&lang=js"
export * from "./DoLogout.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__